import { render, staticRenderFns } from "./EditProyect.vue?vue&type=template&id=446150b4"
import script from "./EditProyect.vue?vue&type=script&lang=js"
export * from "./EditProyect.vue?vue&type=script&lang=js"
import style0 from "./EditProyect.vue?vue&type=style&index=0&id=446150b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports